// import React ,{useEffect} from 'react'
// import Navbar from '../Navbar/Navbar'
// import Box from '@mui/material/Box'
// import Typography from '@mui/material/Typography'
// import heroimg from "../../assets/heromain.jpg"
// import mobile from "../../assets/mobilepriview.png"
// import "./Home.css"
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faDesktop, faCode, faBullhorn,faMagnifyingGlass,faUserTie, faListCheck } from '@fortawesome/free-solid-svg-icons'
// import Footer from '../Footer/Footer'


// import useMediaQuery from '@mui/material/useMediaQuery'
// import { useTheme } from '@mui/material/styles'








// const Home = () => {
//   const theme = useTheme()
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

//   useEffect(() => {
//   AOS.init({
//     duration: 1000, // animation duration in ms
//     once: false,     // whether animation should happen only once
//   });
// }, []);
//   return (
//     <div>
//         <Navbar/>
//         <Box className="hero-main-container">
//           <Box sx={{padding:"1rem", display:"felx", flexDirection:"column", gap:"2rem"}} data-aos="fade-right">
//             <Typography variant="h3" color="initial" sx={{fontWeight:"Bold", fontFamily:"rubik"}}>Find Your <span style={{color:"blue", fontWeight:'bold'}}>Dream Job</span> Make Your Goal</Typography>
//             <Typography variant="p" sx={{color:"gray"}}>Connecting talent with opportunities worldwide. Start your journey to career success today</Typography>
//             <Box sx={{marginTop:"0.5rem"}}>
//               <a href="https://play.google.com/store/apps/details?id=com.inv.jobtools2025&pcampaignid=web_share" target='blank'><button className='find-btn'>Find Job</button></a>
//             </Box>
//           </Box>
//           <img src={heroimg} alt="hero" className='hero-img'/>
//         </Box>
//         {/* category section */}
//         <Box className="job-category-container">
//           <Box className="job-text-conatiner">
//             <Typography variant="h3" color="initial" sx={{fontWeight:"bold"}}><span style={{color:"blue", fontWeight:"bold"}}>Job</span> Category</Typography>
//             <Typography variant="p" color="gray">Get the most exciting jobs and grow your career fast with others</Typography>
//           </Box>
//           <Box className="job-list-conatiner">
//             <Box className="list-one">
//               <Box className="job-card">
//                 <Box sx={{width:"20%"}}>
//                   <FontAwesomeIcon icon={faDesktop} className='icon-img' />
//                 </Box>
//                 <Box sx={{width:"80%"}}>
//                   <Typography variant="p" color="initial">UI/UX Designer</Typography>
//                 </Box>
//               </Box>
//               <Box className="job-card">
//                   <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faCode}  className='icon-img'/>
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Website Development</Typography>
//                   </Box> 
//               </Box>
//               <Box className="job-card">
//                   <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Digital Marketing</Typography>
//                   </Box> 
//               </Box>
//             </Box>

//             <Box className="list-one">
//               <Box className="job-card">
//                 <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Digital Marketing</Typography>
//                   </Box> 
//               </Box>
//               <Box className="job-card">
//                   <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Digital Marketing</Typography>
//                   </Box> 
//               </Box>
//               <Box className="job-card">
//                   <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Digital Marketing</Typography>
//                   </Box> 
//               </Box>
//             </Box>

//             <Box className="list-one">
//               <Box className="job-card">
//                 <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Digital Marketing</Typography>
//                   </Box> 
//               </Box>
//               <Box className="job-card">
//                   <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Digital Marketing</Typography>
//                   </Box> 
//               </Box>
//               <Box className="job-card">
//                   <Box sx={{width:"20%"}}>
//                     <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
//                   </Box>
//                   <Box sx={{width:"80%"}}>
//                     <Typography variant="p" color="initial">Digital Marketing</Typography>
//                   </Box> 
//               </Box>
//             </Box>
//           </Box>
//           <Box display="" mx="" my="" sx="">
//             <a href="https://play.google.com/store/apps/details?id=com.inv.jobtools2025&pcampaignid=web_share" target='blank'><button className='find-btn'>Find More</button></a>
//           </Box>
//         </Box>

//         {/* secton 2 apply process*/}
//         <Box className="apply-section">
//           <Box sx={{textAlign:"center", color:"#fff"}}>
//             <Typography variant="p" color="red">Apply Process</Typography>
//             <Typography variant="h3" fontWeight="bold" fontFamily="rubik">How It Works</Typography>
//           </Box>
//           <Box className="apply-steps-container">
//             <Box className="apply-card" data-aos="flip-left">
//               <FontAwesomeIcon icon={faMagnifyingGlass} style={{fontSize:"32px"}} />
//               <Box sx={{textAlign:"center"}}>
//                 <Typography variant="h6" sx={{fontWeight:'bold'}}>1. Search Job</Typography>
//                 <Typography variant="p">Search, apply, and get hired—fast and easy on sabkajobs.com.</Typography>
//               </Box>
//             </Box>

//             <Box className="apply-card" data-aos="flip-left">
//               <FontAwesomeIcon icon={faListCheck} style={{fontSize:"32px"}}/>
//               <Box sx={{textAlign:"center"}}>
//                 <Typography variant="h6" sx={{fontWeight:'bold'}}>2. Apply Job</Typography>
//                 <Typography variant="p">Search, apply, and get hired—fast and easy on sabkajobs.com.</Typography>
//               </Box>
//             </Box>

//             <Box className="apply-card" data-aos="flip-left">
//               <FontAwesomeIcon icon={faUserTie} style={{fontSize:'32px'}} />
//               <Box sx={{textAlign:"center"}}>
//                 <Typography variant="h6" sx={{fontWeight:'bold'}}>3. Get Your Job Job</Typography>
//                 <Typography variant="p">Search, apply, and get hired—fast and easy on sabkajobs.com.</Typography>
//               </Box>
//             </Box>
//           </Box>
//         </Box>

//         {/* section about-app container */}
//         <Box className="about-app-container">
//           <img src={mobile} alt="mobile" className='mobile-img' data-aos="flip-left"/>
//           <Box className="about-app-text-container">
//             <Typography variant="p" color="blue">Download & Enjoy</Typography>
//             <Typography variant={isMobile ? "h4" : "h3"} color="initial">Get The Job Tools App</Typography>
//             <Typography variant={isMobile ? "h4" : "h3"} color="initial">Search App</Typography>
//             <Box sx={{marginTop:"10px"}}>
//               <a href="https://play.google.com/store/apps/details?id=com.inv.jobtools2025&pcampaignid=web_share"><button className='download-btn'>Download Now</button></a>
//             </Box>
//           </Box>
//         </Box>
        
//         <Footer/>
//     </div>
//   )
// }

// export default Home






import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar/Navbar'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import heroimg from "../../assets/heromain.jpg"
import mobile from "../../assets/mobilepriview.png"
import playstore from "../../assets/google-play.png"
import "./Home.css"
import AOS from 'aos';
import 'aos/dist/aos.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDesktop, faCode, faBullhorn, faMagnifyingGlass, faUserTie, faListCheck, faHandHoldingMedical, faShieldHalved, faPen, faBuildingColumns, faArrowUpRightDots, faVideo} from '@fortawesome/free-solid-svg-icons'
import Footer from '../Footer/Footer'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

// Material UI Dialog imports
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

const Home = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  // Popup state
  const [open, setOpen] = useState(true)
  

  const handleClose = () => {
    setOpen(false)
  }

  const handlePopupSubmit = () => {
    // You can handle the popup input here (e.g., send to API, etc.)
    window.location.href = "https://play.google.com/store/apps/details?id=com.inv.jobtools2025&pcampaignid=web_share"
    setOpen(false)
  }

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: false,     // whether animation should happen only once
    });
  }, []);

  return (
    <div>
      {/* Popup Dialog */}
      <Dialog open={open} onClose={handleClose} sx={{display:"felx", flexDirection:"column", justifyContent:"center", alignItems:"center",p:3, textAlign:"center"}}>
        <DialogTitle>Welcome to SABKA JOBS</DialogTitle>
        <DialogContent>
          <img src={heroimg} alt="img" style={{width:'50%'}} />
        </DialogContent>
        <DialogActions sx={{textAlign:"center", justifyContent:"center"}}>
          <Button onClick={handlePopupSubmit} color="primary" variant="contained">
            Visit Playstore
          </Button>
        </DialogActions>
      </Dialog>

      <Navbar />
      <Box className="hero-main-container">
        <Box sx={{ padding: "1rem", display: "flex", flexDirection: "column", gap: "2rem" }} data-aos="fade-right">
          <Typography variant="h3" color="initial" sx={{ fontWeight: "Bold", fontFamily: "rubik" }}>
            Find Your <span style={{ color: "blue", fontWeight: 'bold' }}>Dream Job</span> Make Your Goal
          </Typography>
          <Typography variant="p" sx={{ color: "gray" }}>
            Connecting talent with opportunities worldwide. Start your journey to career success today
          </Typography>
          <Box sx={{ marginTop: "0.5rem" }}>
            <a href="https://play.google.com/store/apps/details?id=com.inv.jobtools2025&pcampaignid=web_share" target='blank' style={{textDecoration:"none"}}>
              <button className='find-btn'><img src={playstore} alt="play" style={{width:"25%"}} /><span>Download</span></button>
            </a>
          </Box>
        </Box>
        <img src={heroimg} alt="hero" className='hero-img' />
      </Box>
      {/* category section */}
      <Box className="job-category-container">
        <Box className="job-text-conatiner">
          <Typography variant="h3" color="initial" sx={{ fontWeight: "bold" }}>
            <span style={{ color: "blue", fontWeight: "bold" }}>Job</span> Category
          </Typography>
          <Typography variant="p" color="gray">Get the most exciting jobs and grow your career fast with others</Typography>
        </Box>
        <Box className="job-list-conatiner">
          <Box className="list-one">
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faDesktop} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%", textAlign:"left" }}>
                <Typography variant="p" color="initial">UI/UX Designer</Typography>
              </Box>
            </Box>
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faCode} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%",textAlign:"left" }}>
                <Typography variant="p" color="initial">Website Development</Typography>
              </Box>
            </Box>
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faBullhorn} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%", textAlign:"left" }}>
                <Typography variant="p" color="initial">Digital Marketing</Typography>
              </Box>
            </Box>
          </Box>

          <Box className="list-one">
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faHandHoldingMedical} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%", textAlign:"left" }}>
                <Typography variant="p" color="initial">Health & Care</Typography>
              </Box>
            </Box>
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faShieldHalved} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%", textAlign:"left" }}>
                <Typography variant="p" color="initial">Cyber Security</Typography>
              </Box>
            </Box>
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faPen} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%", textAlign:"left" }}>
                <Typography variant="p" color="initial">Content Writing</Typography>
              </Box>
            </Box>
          </Box>

          <Box className="list-one">
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faBuildingColumns} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%", textAlign:"left" }}>
                <Typography variant="p" color="initial">Bank Job</Typography>
              </Box>
            </Box>
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faArrowUpRightDots} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%",textAlign:"left" }}>
                <Typography variant="p" color="initial">Sales</Typography>
              </Box>
            </Box>
            <Box className="job-card" data-aos="flip-left">
              <Box sx={{ width: "20%" }}>
                <FontAwesomeIcon icon={faVideo} className='icon-img' />
              </Box>
              <Box sx={{ width: "80%", textAlign:"left" }}>
                <Typography variant="p" color="initial">Video & Animation</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box display="" mx="" my="" sx="">
          <a href="https://play.google.com/store/apps/details?id=com.inv.jobtools2025&pcampaignid=web_share" target='blank' style={{textDecoration:"none"}}>
            <button className='find-btn'>Find More</button>
          </a>
        </Box>
      </Box>

      {/* secton 2 apply process*/}
      <Box className="apply-section">
        <Box sx={{ textAlign: "center", color: "#fff" }}>
          <Typography variant="p" color="red">Apply Process</Typography>
          <Typography variant="h3" fontWeight="bold" fontFamily="rubik">How It Works</Typography>
        </Box>
        <Box className="apply-steps-container">
          <Box className="apply-card" data-aos="flip-left">
            <FontAwesomeIcon icon={faMagnifyingGlass} style={{ fontSize: "32px" }} />
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>1. Search Job</Typography>
              <Typography variant="p">Search, apply, and get hired—fast and easy on sabkajobs.com.</Typography>
            </Box>
          </Box>

          <Box className="apply-card" data-aos="flip-left">
            <FontAwesomeIcon icon={faListCheck} style={{ fontSize: "32px" }} />
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>2. Apply Job</Typography>
              <Typography variant="p">Search, apply, and get hired—fast and easy on sabkajobs.com.</Typography>
            </Box>
          </Box>

          <Box className="apply-card" data-aos="flip-left">
            <FontAwesomeIcon icon={faUserTie} style={{ fontSize: '32px' }} />
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>3. Get Your Job Job</Typography>
              <Typography variant="p">Search, apply, and get hired—fast and easy on sabkajobs.com.</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* section about-app container */}
      <Box className="about-app-container">
        <img src={mobile} alt="mobile" className='mobile-img' data-aos="flip-left" />
        <Box className="about-app-text-container">
          <Typography variant="p" color="blue">Download & Enjoy</Typography>
          <Typography variant={isMobile ? "h4" : "h3"} color="initial">Get The Sabka Jobs App</Typography>
          <Typography variant={isMobile ? "h4" : "h3"} color="initial">Search App</Typography>
          <Box sx={{ marginTop: "10px" }}>
            <a href="https://play.google.com/store/apps/details?id=com.inv.jobtools2025&pcampaignid=web_share">
              <button className='download-btn'>Download Now</button>
            </a>
          </Box>
        </Box>
      </Box>

      <Footer />
    </div>
  )
}

export default Home








